'use client';

import { useEffect } from 'react';
import { API_URLS } from '$constants/apis';
import { useFetch, useLoadingRouter } from '@brahma/hooks';
import { interpolateString } from '@brahma/utils';
import type { PlatformPreferences } from '@dfg/entity-library/pure-types';
import { PLATFORM_TYPES } from '@dfg/entity-library/pure-types';
import useGlobalContext from '$hooks/use-global-context';
import { ContextAction } from '$context/global-context/types';
import { Loader } from '@brahma/components';
import { COMMON, DEFAULT_LNG, LANGUAGE_PREFERENCE_KEY, LANGUAGES } from '$locale/constants';
import type { IBFFResponse } from '@dfg/brahma-types';
import useLocale from '$hooks/use-locale';
import { useParams } from 'next/navigation';
const CoBrandDetails: React.FC = () => {
  const {
    t
  } = useLocale(COMMON);
  const {
    dispatch
  } = useGlobalContext();
  const params = useParams();
  const {
    router
  } = useLoadingRouter();
  const currentLang = params.lang ?? DEFAULT_LNG;
  const fullUrl = typeof window !== 'undefined' && window.location.href ? window.location.href : '';
  const encodedUrl = encodeURI(fullUrl);
  const {
    data: coBrandDetailResponse,
    loading: coBrandDetailFetchLoading
  } = useFetch<IBFFResponse<PlatformPreferences>>({
    url: interpolateString(API_URLS.getPlatformPreferenceForCoBrandDetails, {
      url: encodedUrl,
      platformType: PLATFORM_TYPES.VERIFIER
    }),
    component: 'CoBrandDetail'
  });
  useEffect(() => {
    if (coBrandDetailResponse?.code === 200) {
      if (coBrandDetailResponse.data && Object.keys(coBrandDetailResponse.data).length) {
        dispatch({
          type: ContextAction.setCoBrandDetails,
          payload: {
            name: coBrandDetailResponse.data?.id ?? '',
            logo: coBrandDetailResponse.data?.logo?.mainLogo ?? '',
            smallLogo: coBrandDetailResponse.data?.logo?.minimizedNavbarLogo ?? '',
            lang: coBrandDetailResponse.data?.language?.code?.toLowerCase() ?? ''
          }
        });
        const previousLanguagesPreference = typeof localStorage !== 'undefined' && localStorage.getItem(LANGUAGE_PREFERENCE_KEY);
        if (!previousLanguagesPreference && currentLang !== coBrandDetailResponse.data?.language?.code?.toLowerCase() && LANGUAGES.includes(coBrandDetailResponse.data?.language?.code?.toLowerCase())) {
          router.push(fullUrl.replace(`/${currentLang}/`, `/${coBrandDetailResponse.data?.language?.code?.toLowerCase()}/`));
          dispatch({
            type: ContextAction.setLang,
            payload: coBrandDetailResponse.data?.language?.code?.toLowerCase() ?? ''
          });
        }
      } else {
        dispatch({
          type: ContextAction.setCoBrandDetails,
          payload: {
            name: '',
            logo: '',
            smallLogo: '',
            lang: ''
          }
        });
      }
    }
  }, [coBrandDetailResponse]);
  return <Loader loaderText={t(`loader.text`)} show={coBrandDetailFetchLoading} data-sentry-element="Loader" data-sentry-component="CoBrandDetails" data-sentry-source-file="co-brand.tsx" />;
};
export default CoBrandDetails;